module.exports = __webpack_public_path__ + "9fcd2f770325072c26ed9f5ca0589020.png";